import React, { Component } from 'react';
import { Modal, Header, Button } from 'semantic-ui-react';

import ExceptionForm from './ExceptionForm';
import { SchoolCalendarFieldEnum as Fields } from 'Common/FieldEnum';

class ExceptionModal extends Component {
  onAddClick = () => {
    this.props.onActionClick();
  };

  render() {
    const {
      onClose,
      exception,
      onSubmit,
      isAdd,
      firstDay,
      lastDay,
    } = this.props;
    const title = isAdd ? 'New Exception' : exception[Fields.Description];

    return (
      <Modal
        closeIcon
        closeOnDimmerClick={false}
        onClose={onClose}
        open
        size={'tiny'}
      >
        <Header content={title} icon={isAdd ? 'add' : 'pencil'} />
        <Modal.Content className="p-t-0">
          <ExceptionForm
            initialValues={exception}
            firstDay={firstDay}
            lastDay={lastDay}
            onSubmit={onSubmit}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={this.onAddClick}
            inverted
            color="orange"
            size="big"
            content={isAdd ? 'Add' : 'Update'}
            type="submit"
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

export { ExceptionModal };



// WEBPACK FOOTER //
// ./src/pages/schoolcalendar/components/ExceptionModal.js